// Libs
// Components, Layouts, Pages
import { InvoicePageTemplate } from '~/pages/template';
// Others
// Styles, images, icons

type Props = {};

const InvoicePageStaff = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return <InvoicePageTemplate />;
};

export default InvoicePageStaff;
